import { INDIVIDUAL_EDITS_LIMIT } from 'modules/bulkEdit/constants';

export const maxEditsReached = (numberOfEdits: number, receivingValue: number): boolean => {
    return numberOfEdits >= INDIVIDUAL_EDITS_LIMIT && !receivingValue;
};
